export enum Breakpoints {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export interface BreakpointsPxProps {
  sm: string
  md: string
  lg: string
  xl: string
}

export interface BreakpointsProps {
  sm: number
  md: number
  lg: number
  xl: number
}

export const breakPoints: BreakpointsProps = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
}

export const breakPointsPx: BreakpointsPxProps = {
  sm: `${breakPoints.sm}px`,
  md: `${breakPoints.md}px`,
  lg: `${breakPoints.lg}px`,
  xl: `${breakPoints.xl}px`,
}
